import React from 'react';
/* This files links all pages components "entry points" of a project */
// MODULES_APPEND_INDEX_ON_IMPORTS

export const modules = [
  {
    id: 'EmptyPage',
    loader: React.lazy(() => import('../../src/pages/Empty')),
  },
  {
    id: 'AfterSaleParentProductSelectorPage',
    loader: React.lazy(() => import('../../src/pages/AfterSaleParentProductSelector')),
  },
  {
    id: 'OBDErrorPage',
    loader: React.lazy(() => import('../../src/pages/OBDError')),
  },
  {
    id: 'OBDResidenceErrorPage',
    loader: React.lazy(() => import('../../src/pages/OBDResidenceError')),
  },
  {
    id: 'PersonalDataPage',
    loader: React.lazy(() => import('../../src/pages/PersonalData')),
  },
  {
    id: 'ProductOfferingToBuyChangedPage',
    loader: React.lazy(() => import('../../src/pages/ProductOfferingToBuyChangedPage')),
  },
  {
    id: 'PermanentResidencePage',
    loader: React.lazy(() => import('../../src/pages/PermanentResidence')),
  },
  {
    id: 'SelectParentProduct',
    loader: React.lazy(() => import('../../src/pages/SelectParentProduct')),
  },
  {
    id: 'Installation',
    loader: React.lazy(() => import('../../src/pages/Installation')),
  },
  {
    id: 'MainAction',
    loader: React.lazy(() => import('../../src/pages/MainAction')),
  },
  {
    id: 'MobileSecondaryAction',
    loader: React.lazy(() => import('../../src/pages/MobileSecondaryAction')),
  },
  {
    id: 'LandLineSecondaryAction',
    loader: React.lazy(() => import('../../src/pages/LandLineSecondaryAction')),
  },
  {
    id: 'PortabilityOTP',
    loader: React.lazy(() => import('../../src/pages/PortabilityOTP')),
  },
  {
    id: 'AlreadyOwnedProductsChoices',
    loader: React.lazy(() => import('../../src/pages/AlreadyOwnedProductsChoices')),
  },
  {
    id: 'CommitmentPage',
    loader: React.lazy(() => import('../../src/pages/Commitment')),
  },
  {
    id: 'PpipPage',
    loader: React.lazy(() => import('../../src/pages/Ppip')),
  },
  {
    id: 'DeviceInstallationPage',
    loader: React.lazy(() => import('../../src/pages/DeviceInstallation')),
  },
  {
    id: 'ShipmentPage',
    loader: React.lazy(() => import('../../src/pages/Shipment')),
  },
  {
    id: 'PaymentPage',
    loader: React.lazy(() => import('../../src/pages/Payment')),
  },
  {
    id: 'RiskPage',
    loader: React.lazy(() => import('../../src/pages/Risk')),
  },
  {
    id: 'ScoringPage',
    loader: React.lazy(() => import('../../src/pages/Scoring')),
  },
  {
    id: 'SummaryPage',
    loader: React.lazy(() => import('../../src/pages/Summary')),
  },
  {
    id: 'OneClickSummaryPage',
    loader: React.lazy(() => import('../../src/pages/OneClickSummary')),
  },
  {
    id: 'ManualSummaryPage',
    loader: React.lazy(() => import('../../src/pages/ManualSummary')),
  },
  {
    id: 'PackSummaryPage',
    loader: React.lazy(() => import('../../src/pages/PackSummary')),
  },
  {
    id: 'ActivationSummaryPage',
    loader: React.lazy(() => import('../../src/pages/ActivationSummary')),
  },
  {
    id: 'DeviceSummaryPage',
    loader: React.lazy(() => import('../../src/pages/DeviceSummary')),
  },
  {
    id: 'ChooseNumberOTPPage',
    loader: React.lazy(() => import('../../src/pages/ChooseNumberOTP')),
  },
  {
    id: 'SignaturePage',
    loader: React.lazy(() => import('../../src/pages/Signature')),
  },
  {
    id: 'VTLSummaryPage',
    loader: React.lazy(() => import('../../src/pages/VTLSummary')),
  },
  {
    id: 'VTLCardPaymentPage',
    loader: React.lazy(() => import('../../src/pages/VTLCardPayment')),
  },
  {
    id: 'DeviceConfirmationPage',
    loader: React.lazy(() => import('../../src/pages/DeviceConfirmation')),
  },
  {
    id: 'DuoSummaryPage',
    loader: React.lazy(() => import('../../src/pages/DuoSummary')),
  },
  {
    id: 'ConfirmationPage',
    loader: React.lazy(() => import('../../src/pages/Confirmation')),
  },
  {
    id: 'CreditLimitErrorPage',
    loader: React.lazy(() => import('../../src/pages/CreditLimitError')),
  },
  {
    id: 'RiskErrorPage',
    loader: React.lazy(() => import('../../src/pages/RiskError')),
  },
  {
    id: 'DebtErrorPage',
    loader: React.lazy(() => import('../../src/pages/DebtError')),
  },
  {
    id: 'NumberOfSimsPage',
    loader: React.lazy(() => import('../../src/pages/NumberOfSims')),
  },
  // MODULES_APPEND_INDEX_ON_MODULES
];
